import React from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { selectIsAuthenticated, logout } from "../features/auth/authSlice";
import { Breadcrumb, BreadcrumbItem } from "@/components/ui/breadcrumb";
import { ChevronLeft } from "lucide-react";
import { SidebarTrigger } from "@/components/ui/sidebar";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

const Navbar: React.FC = () => {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(selectIsAuthenticated);

  return (
    <header className="bg-sidebar border-b border-sidebar-border sticky top-0 z-40">
      <div className="container mx-auto px-4 py-2 flex justify-between items-center">
        {/* breadcrumb */}
        <div className="flex items-center gap-2">
          {/* sidebar toggle button */}
          <SidebarTrigger className="mr-2" />
          <Breadcrumb className="hidden md:block">
            <BreadcrumbItem>
              <Link to="/">Home</Link>
            </BreadcrumbItem>
          </Breadcrumb>
        </div>

        <nav className="flex items-center space-x-4">
          <Select defaultValue="all">
            <SelectTrigger className="w-32 h-8">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectGroup>
                <SelectItem value="all">All Farms</SelectItem>
                <SelectItem value="farm1">Farm 1</SelectItem>
                <SelectItem value="farm2">Farm 2</SelectItem>
              </SelectGroup>
            </SelectContent>
          </Select>
          <Avatar className="w-8 h-8">
            <AvatarImage src="https://github.com/shadcn.png" />
            <AvatarFallback>CN</AvatarFallback>
          </Avatar>
          {isAuthenticated ? (
            <>
              <Link
                to="/dashboard"
                className="hover:text-pink-400 transition-colors"
              >
                Dashboard
              </Link>
              <button
                onClick={() => dispatch(logout())}
                className="hover:text-pink-400 transition-colors"
              >
                Logout
              </button>
            </>
          ) : (
            <Link to="/auth/login" className="hover:text-pink-400 transition-colors">
              Login
            </Link>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Navbar;
